/**
 * A convenient Template Literal Tag Function to strip out newlines and extraneous whitespace.
 * Useful when you want to write a long string over multiple lines and use indentation to keep it aligned in the editor,
 * but also want it to render in the DOM as a single line, with no hard line breaks or extra spaces.
 *
 * See {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#tagged_templates|MDN: Tagged Templates}
 *
 * @example
 * const longString = stripNewlines`
 *      Here is a long string
 *      that wraps over ${1 + 1 + 1}
 *      lines!
 * `
 * // "Here is a long string that wraps over 3 lines!"
 * @param {TemplateStringsArray} strings Array of Strings in the Template Literal
 * @param placeholders Array of evaluated expressions in the Template Literal
 * @returns The evaluated string - with newlines and multiple spaces stripped
 */
export const oneLine = (strings, ...placeholders) => {
    const evaluatedString = placeholders.reduce((previousString, currentPlaceholder, index) => {
        return previousString + currentPlaceholder + strings[index + 1]
    }, strings[0])

    return evaluatedString.replace(/\s\s+/g, " ").trim()
}
